import React, { useEffect } from "react";
import { RightOutlined } from "@ant-design/icons";
import { NavLink } from "../../../../lib/Navigation";
import "./css/card.css";

export default function Card(props) {

  const card = props.children;

  return (
    <div className="voucher-card-index">
      <div className="voucher-card-container">
        <div className="voucher-card-header">
          <div className="voucher-card-header-title">
            <div>
              开通<span className="heighlight">省钱卡</span>，最高可得
              <span className="heighlight">{card.old_oversea_amount}元</span>
            </div>
          </div>
          <NavLink to="/save/newcard" className="voucher-card-header-detail">
            <div className="text">详情</div>
            <RightOutlined style={{color:'#999',fontSize: '14px'}}></RightOutlined>
          </NavLink>
        </div>

        <div className="voucher-card-body">
          <div className="voucher-card-body-item">
            <div className="voucher-card-body-item-title">开通立返</div>
            <div className="voucher-card-body-item-img">
              <img
                src="/resources/250627/voucher_card_1.png"
                alt="开通立返"
                height="46"
              />
              <div className="voucher-card-body-item-img-text">{card.amount}元金币</div>
            </div>
            <div className="voucher-card-body-item-subtitle">立返{card.amount}元金币</div>
          </div>

          <div className="voucher-card-body-item">
            <div className="voucher-card-body-item-title">每日福利2选1×7天</div>
            <div className="voucher-card-body-item-img">
              <img
                src="/resources/250627/voucher_card_2.png"
                alt="每日福利2选1×7天"
                height="46"
              />
            </div>
            <div className="voucher-card-body-item-subtitle">
              {card.sumVoucherDesc}&nbsp;&nbsp;&nbsp;&nbsp;{card.sumBalanceDesc}
            </div>
          </div>

          <div className="voucher-card-body-item">
            <div className="voucher-card-body-item-title">开通即回本</div>
            <div className="voucher-card-body-item-img">
              <div className="voucher-card-body-item-now-price">{card.first_amount}</div>
              <div className="voucher-card-body-item-original-price">￥{card.old_oversea_amount}</div>
            </div>
            <NavLink to={`/save/newcard?grade_id=${card.grade_id}`} className="voucher-card-body-item-subtitle">立即开通</NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}
